import { combineReducers } from 'redux'
import shared from './reducers/shared'

export default combineReducers({
    shared
})